import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import { IconButton, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { ImageCarouselSkeleton } from './Skeleton.tsx';
import { Container, ControlContainer, Count, ImageContainer, OfTotal } from './styled.ts';
import { type Props } from './types.ts';

export const ImageCarousel = ({ images, renderImage }: Props) => {
  const [activeImageIndex, setActiveImageIndex] = useState<number>(0);
  const theme = useTheme();

  return images.length > 0 ? (
    <div>
      <Container>
        <ControlContainer
          onClick={() => {
            if (activeImageIndex > 0) {
              setActiveImageIndex(activeImageIndex - 1);
            }
          }}
          sx={{
            height: '100%',
            left: 0,
            paddingLeft: theme.spacing(1),
            position: 'absolute',
            top: 0,
            zIndex: 1,
          }}
        >
          <IconButton
            aria-label="Go back"
            disabled={activeImageIndex === 0}
            sx={{
              color: ({ palette }) => palette.grey[100],
            }}
          >
            <ArrowBackIosNew
              sx={{
                filter: 'drop-shadow(0px 1px 1px rgb(0 0 0 / 0.4))',
                fontSize: '2.5rem',
              }}
            />
          </IconButton>
        </ControlContainer>
        <ImageContainer>
          {images[activeImageIndex] ? renderImage({ src: images[activeImageIndex] }) : undefined}
        </ImageContainer>
        <ControlContainer
          onClick={() => {
            if (activeImageIndex < images.length - 1) {
              setActiveImageIndex(activeImageIndex + 1);
            }
          }}
          sx={{
            height: '100%',
            paddingRight: theme.spacing(1),
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: 1,
          }}
        >
          <IconButton
            aria-label="Go forward"
            disabled={activeImageIndex === images.length - 1}
            sx={{
              color: ({ palette }) => palette.grey[100],
            }}
          >
            <ArrowForwardIos
              sx={{
                filter: 'drop-shadow(0px 1px 1px rgb(0 0 0 / 0.4))',
                fontSize: '2.5rem',
              }}
            />
          </IconButton>
        </ControlContainer>
      </Container>
      <Count>
        <Typography sx={{ color: theme.mainTextPrimary }}>
          <strong>{activeImageIndex + 1}</strong>
          <OfTotal>/{images.length}</OfTotal>
        </Typography>
      </Count>
    </div>
  ) : (
    <ImageCarouselSkeleton />
  );
};
